import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import { setAction, createChartAction, createLayoutAction, createTableAction } from '../actions/showChartPage';
import { setAction as setProfileAction } from '../../../redux/actions/profile';
import { getProfileConfig } from '../../../redux/selectors/profile';
import actionTypes from '../../../redux/actions/action-types';
import { templatePlugins, getCSVFromText, parseCSV, toCSV, snackBar } from 'highed';
import paths from '../../../paths';
import Helpers from '../../../utils/Helpers';
import {
  getTeamChartWithTeamidAndChartid,
  getShowChartWithUuid,
  postTeamChartUsingTeamid,
  getChartAccesstoWithUuid
} from '../../../api/cloudApiGenerated';
import { isArray } from 'lodash';

let scriptCounter = 0,
  scriptsAmount = 0,
  transformedData,
  constr,
  finishedLoading = false;

function loadModules(paths, loadInExport) {
  paths.forEach(function (path) {
    let s = document.createElement('link');
    s.rel = 'stylesheet';
    s.async = true;
    s.href = path;

    document.getElementsByTagName('head')[0].appendChild(s);
    if (loadInExport) {
      if (window.evervizCSS.externalCSS.indexOf(path) === -1) {
        window.evervizCSS.externalCSS.push(path);
      }
    }
  });
}

function isScriptAlreadyIncluded(scripts, src) {
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].hasAttribute('src')) {
      const scriptTag = scripts[i].getAttribute('src') || '';
      if (
        scriptTag.indexOf(src) >= 0 ||
        (scriptTag.indexOf('highcharts.src.js') > -1 && src === 'highcharts.js') ||
        (scriptTag.indexOf('stock/highstock.js') > -1 && src === 'modules/highstock.js')
      ) {
        return true;
      }
    }
  }
  return false;
}

function processArray(array, fn) {
  let results = [];
  return array.reduce(function (p, item) {
    return p.then(function () {
      return fn(item).then(function (data) {
        results.push(data);
        return results;
      });
    });
  }, Promise.resolve());
}

function makeScriptPromise(path) {
  return new Promise((resolve) => {
    let s,
      done = false;
    let scripts = document.getElementsByTagName('script');
    if (!isScriptAlreadyIncluded(scripts, path)) {
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = path;
      s.onload = handleLoad;
      s.onreadystatechange = handleReadyStateChange;

      function handleLoad() {
        if (!done) {
          done = true;
          scriptCounter++;
          return resolve();
        }
      }

      function handleReadyStateChange() {
        var state;
        if (!done) {
          state = s.readyState;
          if (state === 'complete') {
            handleLoad();
          }
        }
      }
      document.getElementsByTagName('head')[0].appendChild(s);
    } else {
      scriptCounter++;
      return resolve();
    }
  });
}

function loadJSModules(paths, fn) {
  //const that = this;
  return processArray(paths, makeScriptPromise);
}

export function* createTable(params) {
  const { project } = params.data;
  let options = JSON.parse(project.data);

  loadModules([window.hcconfig.frontend.hostname + '/resources/tables/1.0/css/table.css'], false);

  if (options && options.cssModules && options.cssModules.length) {
    loadModules(options.cssModules, true);
  }

  let table = {
    template: options.template || [],
    data: options.data || {}
  };

  table.options = Helpers.merge({}, Helpers.merge(options.theme.options || {}, options.options || {}));

  new EvervizTable('everviz-table-project', table);
}

// eslint-disable-next-line require-yield
export function* createLayout(params) {
  const { project } = params.data;
  let options = JSON.parse(project.data);
  options = options.pages[0];
  let layoutType = options.options.layout.type;
  const moduleOptions = {
    carousel: window.hcconfig.frontend.hostname + '/resources/layouts/1.0/js/carousel.js',
    tabs: window.hcconfig.frontend.hostname + '/resources/layouts/1.0/js/tabs.js',
    dropdown: window.hcconfig.frontend.hostname + '/resources/layouts/1.0/js/dropdown.js',
    slider: window.hcconfig.frontend.hostname + '/resources/layouts/1.0/js/slider.js'
  };

  let moduleToLoad = window.hcconfig.frontend.hostname + '/resources/layouts/1.0/js/basic.js';
  let constr = 'basic';
  if (moduleOptions.hasOwnProperty(layoutType)) {
    moduleToLoad = moduleOptions[layoutType];
    constr = layoutType;
  }

  let layout = {
    template: options.template || [],
    data: options.data || []
  };

  layout.options = Helpers.merge({}, Helpers.merge(options.theme.options || {}, options.options || {}));
  loadModules([window.hcconfig.frontend.hostname + '/resources/layouts/1.0/css/layout.min.css'], false);
  loadJSModules([moduleToLoad]).then(() => {
    // eslint-disable-next-line no-undef
    new EvervizLayout[constr]('everviz-layout-project', layout);
  });
}

export function* createChart(params) {
  const { chart } = params.data;
  let evervizWatermark = {
    credits: {
      enabled: true,
      text: 'Powered by everviz',
      style: {
        fontFamily: 'RadioGrotesk Regular',
        fontSize: 14,
        color: '#172B4C'
      }
    }
  };
  let customCode;
  transformedData = {};
  let pluginOptions = {};
  let templateDataSettings = {};

  const options = JSON.parse(chart.data);
  scriptsAmount = 0;
  scriptCounter = 0;
  finishedLoading = false;

  let parseData = false;
  if (chart.details) {
    try {
      options.settings.dataProvider = JSON.parse(chart.details);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  if (options.theme && options.theme.plugins && options.theme.plugins.cssModules) {
    loadModules(options.theme.plugins.cssModules, true);
  }
  if (options.settings && options.settings.plugins) {
    Object.keys(options.settings.plugins).filter(function (key) {
      if (key === 'cssModules') {
        loadModules(options.settings.plugins.cssModules, true);
      } else {
        if (templatePlugins[key]) {
          if (templatePlugins[key].modules) {
            scriptsAmount += templatePlugins[key].modules.length;
            loadJSModules(templatePlugins[key].modules, transformedData).then(function () {
              if (scriptCounter === scriptsAmount) {
                if (finishedLoading) {
                  new Highcharts[constr]('everviz-layout-project', transformedData);
                  setTimeout(() => {
                    Highcharts.charts.forEach((chart) => {
                      if (chart && chart.reflow) chart.reflow();
                    });
                  }, 1000);
                }
              }
            });
          }
          if (templatePlugins[key].config) {
            //Has a special config that needs to be merged in with the options, normally an event or something
            pluginOptions = templatePlugins[key].config;
          }
          if (templatePlugins[key].parseData) parseData = templatePlugins[key].parseData;
        }
      }
    });
  }

  if (options.settings && options.settings.templateDataSettings) {
    templateDataSettings = options.settings.templateDataSettings;
  }

  if (options?.theme?.options?.chart?.type) {
    if (
      options.theme.options.series &&
      Helpers.isArr(options.theme.options.series) &&
      options.theme.options.series.length > 0
    ) {
      const allEqual = (arr) => arr.every((v) => v.type === arr[0].type);
      const series = options.theme.options.series;
      if (series[0].type && allEqual(series)) {
        if (!options.theme.options.chart) options.theme.options.chart = {};
        options.theme.options.chart.type = series[0].type;
      }
    }
  }

  transformedData = Highcharts.merge(transformedData, (options.theme ? options.theme.options : {}) || {});
  transformedData = Helpers.merge(transformedData, pluginOptions);

  let aggregatedTemplate = {};

  if (options.template) {
    if (Helpers.isArr(options.template)) {
      options.template.forEach((template) => {
        if (template) {
          aggregatedTemplate = Helpers.merge(aggregatedTemplate, template);
        }
      });
    } else {
      aggregatedTemplate = Helpers.merge(aggregatedTemplate, options.template || {});
    }
  }

  transformedData = Helpers.merge(transformedData, aggregatedTemplate || {});

  if (options.theme && options.theme.options && options.theme.options.xAxis) {
    options.theme.options.xAxis = Helpers.isArr(options.theme.options.xAxis)
      ? options.theme.options.xAxis
      : [options.theme.options.xAxis];

    if (Helpers.isArr(transformedData.xAxis)) {
      transformedData.xAxis.forEach(function (obj, i) {
        if (i < options.theme.options.xAxis.length) {
          Helpers.merge(obj, options.theme.options.xAxis[i]);
        }
      });
    }
  }

  if (options.theme && options.theme.options && options.theme.options.yAxis) {
    options.theme.options.yAxis = Helpers.isArr(options.theme.options.yAxis)
      ? options.theme.options.yAxis
      : [options.theme.options.yAxis];

    if (Helpers.isArr(transformedData.yAxis)) {
      transformedData.yAxis.forEach(function (obj, i) {
        if (i < options.theme.options.yAxis.length) {
          Helpers.merge(obj, options.theme.options.yAxis[i]);
        }
      });
    }
  }

  transformedData.series = [];
  if (Helpers.isArr(options.options.series)) {
    options.options.series.forEach(function (obj, i) {
      let mergeTarget = {};

      if (aggregatedTemplate && Helpers.isArr(aggregatedTemplate.series)) {
        if (i < aggregatedTemplate.series.length) {
          mergeTarget = Helpers.merge({}, aggregatedTemplate.series[i]);
        }
      }

      if (options.theme.options && Helpers.isArr(options.theme.options.series)) {
        if (i < options.theme.options.series.length) {
          mergeTarget = Helpers.merge({}, options.theme.options.series[i]);
        }
      }

      transformedData.series.push(Helpers.merge(mergeTarget, obj));
    });
  }

  if (options.theme.options && options.theme.options.series) {
    if (transformedData.series) {
      transformedData.series.forEach(function (serie, i) {
        if (!serie.type && options.theme.options.series[i] && options.theme.options.series[i].type) {
          serie.type = options.theme.options.series[i].type;
        }
      });
    }
  }

  Helpers.merge(transformedData, options.options || {}, null, {
    xAxis: 1,
    yAxis: 1,
    series: 1
  });

  if (Helpers.isArr(options.options.series)) {
    if (!transformedData.series) transformedData.series = [];

    (options.options.series || []).forEach((serie, i) => {
      if (transformedData.series[i])
        transformedData.series[i] = Helpers.merge(
          Helpers.merge({}, transformedData.series[i]),
          Helpers.merge({}, serie)
        );
      else transformedData.series[i] = Helpers.merge({}, options.options.series[i]);
    });
  }

  if (options?.options?.xAxis) {
    options.options.xAxis = Helpers.isArr(options.options.xAxis) ? options.options.xAxis : [options.options.xAxis];

    if (transformedData.xAxis && !isArray(transformedData.xAxis)) {
      transformedData.xAxis = [transformedData.xAxis];
    }
    if (options.options.xAxis && Helpers.isArr(options.options.xAxis)) {
      if (!transformedData.xAxis) transformedData.xAxis = [];
      (options.options.xAxis || []).forEach((axis, i) => {
        if (transformedData.xAxis[i])
          transformedData.xAxis[i] = Helpers.merge(
            Helpers.merge({}, transformedData.xAxis[i]),
            Helpers.merge({}, axis)
          );
        else transformedData.xAxis[i] = Helpers.merge({}, options.options.xAxis[i]);
      });
    }
  }

  if (options?.options?.yAxis) {
    options.options.yAxis = Helpers.isArr(options.options.yAxis) ? options.options.yAxis : [options.options.yAxis];

    if (transformedData.yAxis && !isArray(transformedData.yAxis)) {
      transformedData.yAxis = [transformedData.yAxis];
    }

    if (options.options.yAxis && Helpers.isArr(options.options.yAxis)) {
      if (!transformedData.yAxis) transformedData.yAxis = [];
      (options.options.yAxis || []).forEach((axis, i) => {
        if (transformedData.yAxis[i])
          transformedData.yAxis[i] = Helpers.merge(
            Helpers.merge({}, transformedData.yAxis[i]),
            Helpers.merge({}, axis)
          );
        else transformedData.yAxis[i] = Helpers.merge({}, options.options.yAxis[i]);
      });
    }
  }

  if (!transformedData.yAxis && options && options.options.yAxis) {
    transformedData.yAxis = Helpers.merge({}, options.options.yAxis);
  }

  if (!transformedData.xAxis && options && options.options.xAxis) {
    transformedData.xAxis = Helpers.merge({}, options.options.xAxis);
  }

  if (options && options.theme && options.theme.options && options.theme.options.colorAxis) {
    transformedData.colorAxis = options.theme.options.colorAxis;
  }

  if (transformedData.xAxis && Helpers.isArr(transformedData.xAxis) && transformedData.xAxis.length === 1) {
    transformedData.xAxis = transformedData.xAxis[0];
  }

  if (transformedData.yAxis && Helpers.isArr(transformedData.yAxis) && transformedData.yAxis.length === 1) {
    transformedData.yAxis = transformedData.yAxis[0];
  }

  if (options.settings && options.settings.dataProvider) {
    if (options.settings.dataProvider.text) {
      //Wordcloud
      let sections = options.settings.dataProvider.assignDataFields;

      let text = {};

      if (Helpers.isStr(options.settings.dataProvider.text)) text.text = options.settings.dataProvider.text;
      else text = options.settings.dataProvider.text;

      let parsedCSV = parseCSV(getCSVFromText(text.text, text.amount));
      if (sections) {
        sections = Helpers.getAllMergedLabelAndData(sections);
      }
      if (parsedCSV) {
        parsedCSV = Helpers.convertData(parsedCSV, true, sections);
        options.settings.dataProvider.csv = parsedCSV.map((m) => m.join(';')).join('\n');
      }
    }
    if (options.settings.dataProvider.googleSpreadsheet) {
      let sheet = options.settings.dataProvider.googleSpreadsheet;

      transformedData = Helpers.merge(transformedData, {
        data: {
          googleSpreadsheetKey: sheet.id || sheet.googleSpreadsheetKey,
          googleSpreadsheetWorksheet: sheet.worksheet || sheet.googleSpreadsheetWorksheet,
          startRow: sheet.startRow,
          endRow: sheet.endRow,
          startColumn: sheet.startColumn,
          endColumn: sheet.endColumn,
          enablePolling: sheet.enablePolling,
          dataRefreshRate: sheet.dataRefreshRate,
          googleSpreadsheetRange: sheet.googleSpreadsheetRange
        }
      });
    } else if (options.settings.dataProvider.liveData) {
      let live = options.settings.dataProvider.liveData;
      transformedData = Helpers.merge(transformedData, {
        data: live
      });
    } else if (options.settings.dataProvider.csv) {
      if (chart.live) {
        options.settings.dataProvider.csvURL = [paths.url, '/data/', chart.hash].join('');
        delete options.settings.dataProvider.csv;
        transformedData = Highcharts.merge(transformedData, {
          data: options.settings.dataProvider
        });
      } else {
        let sections = options.settings.dataProvider.assignDataFields,
          csv = options.settings.dataProvider.csv.replace('&amp;', '&');
        if (!options.settings.dataProvider.text) {
          if (sections) {
            sections = Helpers.getAllMergedLabelAndData(sections);
            csv = Helpers.parseCSV(csv, null, sections);
            if (parseData) csv = parseData(csv);

            csv = toCSV(csv);
            options.settings.dataProvider.csv = csv;
          }
        }

        Helpers.merge(transformedData, {
          data: {
            csv,
            seriesMapping: options.settings.dataProvider.seriesMapping
          }
        });
      }
    }
  }

  if (chart && transformedData) {
    if (
      window['everviz'] &&
      window['everviz'].tooltipFormatter &&
      transformedData.everviz &&
      transformedData.everviz.tooltip
    ) {
      if (!transformedData.tooltip) transformedData.tooltip = {};
      transformedData.tooltip.formatter = window['everviz'].tooltipFormatter;
    }

    if (options.customCode) {
      customCode = new Function(
        'options',
        [
          'if (options.yAxis && options.yAxis.length === 1) options.yAxis = options.yAxis[0];',
          'if (options.xAxis && options.xAxis.length === 1) options.xAxis = options.xAxis[0];',
          'if (options.zAxis && options.zAxis.length === 1) options.zAxis = options.zAxis[0];'
        ].join('') + options.customCode
      );
    }

    if (customCode instanceof Function) {
      customCode(transformedData);
    }

    if (Highcharts) {
      Highcharts.setOptions({
        plotOptions: {
          series: {
            label: {
              enabled: false
            }
          }
        }
      });
    }

    if (transformedData.options && (transformedData.options.lang || transformedData.options.global)) {
      Highcharts.setOptions({
        global: transformedData.options.global || {},
        lang: transformedData.options.lang || {}
      });
    }

    constr = 'Chart';

    if (options.settings && options.settings.constructor && !Helpers.isFn(options.settings.constructor)) {
      if (Helpers.isArr(options.settings.constructor)) {
        constr =
          options.settings && options.settings.plugins && options.settings.plugins.map
            ? Helpers.isTileMap(options)
              ? 'Chart'
              : 'Map'
            : options.settings.constructor.some(function (a) {
                return a === 'StockChart';
              })
            ? 'StockChart'
            : 'Chart';
      } else {
        constr = options.settings.constructor;
      }
    }

    if (transformedData.xAxis && Helpers.isArr(transformedData.xAxis) && transformedData.xAxis.length === 1) {
      transformedData.xAxis = transformedData.xAxis[0];
    }

    if (transformedData.yAxis && Helpers.isArr(transformedData.yAxis) && transformedData.yAxis.length === 1) {
      transformedData.yAxis = transformedData.yAxis[0];
    }

    if (transformedData.data) {
      if (transformedData && (transformedData.lang || transformedData.global)) {
        Highcharts.setOptions({
          global: transformedData.global || {},
          lang: transformedData.lang || {}
        });
      }

      if (Highcharts.Annotation) {
        Highcharts.Annotation.ControlPoint.prototype.redraw = function (animation) {
          this.graphic[animation ? 'animate' : 'attr'](
            this.options.positioner ? this.options.positioner.call(this, this.target) : null
          );
        };
      }

      transformedData.stockTools = {
        gui: {
          enabled: false
        }
      };

      if (transformedData.annotations && transformedData.annotations.length > 0) {
        //Remove draggable
        transformedData.annotations.forEach((annotation) => {
          annotation.draggable = null;
        });
      }

      if (transformedData.data && !transformedData.data.complete) {
        transformedData.data.complete = function (options) {
          const keys = Object.keys(templateDataSettings || {});
          keys.forEach(function (key) {
            const serie = options.series[key];
            (serie.data || []).forEach(function (d, i) {
              if (templateDataSettings[key].data && templateDataSettings[key].data[i]) {
                Helpers.merge(d, templateDataSettings[key].data[i]);
              }
            });
          });
          return options;
        };
      }

      if (chart.plan_id === 1) {
        Helpers.merge(transformedData, evervizWatermark);
      }

      if (chart.mapData) {
        if (!transformedData.chart) transformedData.chart = {};
        transformedData.chart.map = JSON.parse(chart.mapData);
      }

      if (!transformedData.exporting) transformedData.exporting = {};
      transformedData.exporting.url = 'https://api.everviz.com/export';

      if (transformedData.chart && transformedData.chart.map && Helpers.isStr(transformedData.chart.map)) {
        //const that = this;
        const script = document.createElement('script');
        script.src = 'https://code.highcharts.com/mapdata/' + transformedData.chart.map + '.js';
        script.async = true;

        document.body.appendChild(script);

        script.onload = () => {
          new Highcharts[constr]('everviz-layout-project', transformedData, () => {
            setTimeout(() => {
              // Highcharts.charts.forEach((chart) => { if (chart && chart.reflow) chart.reflow(); });
            }, 1000);
          });
          //that.state.Chart.reflow()
        };
      } else {
        finishedLoading = true;
        if (scriptsAmount === scriptCounter) {
          yield put(
            setAction({
              chartLoaded: true,
              transformedData,
              Chart: new Highcharts[constr]('everviz-layout-project', transformedData)
            })
          );
          setTimeout(() => {
            //Highcharts.charts.forEach((chart) => { if (chart && chart.reflow) chart.reflow(); });
          }, 1000);
          //that.state.Chart.reflow()
        }
      }
    }
  }
}

export function* loadChart(params) {
  const { team, id, setNavActions, duplicateChart, editChart } = params.data;

  var loadChartAjax = function () {
    if (!isNaN(Number(id))) {
      if (team === undefined) return;
      return getTeamChartWithTeamidAndChartid(team.id, id);
    } else {
      return getShowChartWithUuid(id);
    }
  };

  if (!window.evervizCSS) window.evervizCSS = {};

  window.evervizCSS.externalCSS = [];

  try {
    const chart = yield call(loadChartAjax);
    if (chart && chart.data) {
      if (chart.name) chart.name = (chart.name || '').replace(/<[^>]+>/g, '');

      if (chart.chart_type === 4) {
        yield put(
          setAction({
            chart,
            error: '',
            loadedChart: true,
            username: chart.username,
            chartId: chart.chart_id,
            uuid: chart.uuid
          })
        );
        yield put(
          createLayoutAction({
            project: chart
          })
        );
        return;
      } else if (chart.chart_type === 5) {
        yield put(
          setAction({
            chart,
            error: '',
            loadedChart: true,
            username: chart.username,
            chartId: chart.chart_id,
            uuid: chart.uuid
          })
        );
        yield put(
          createTableAction({
            project: chart
          })
        );
        return;
      }

      let actions = [];
      actions.push({
        text: '',
        tooltip: {
          text: 'Duplicate'
        },
        icon: 'bar-chart',
        className: '',
        onClick: () => {
          duplicateChart();
        }
      });
      if (chart.team_owner === 9999998) {
        setNavActions(actions);
        yield put(
          setAction({
            chart,
            error: '',
            loadedChart: true,
            username: chart.username,
            chartId: chart.chart_id,
            uuid: chart.uuid
          })
        );
        yield put(
          createChartAction({
            chart
          })
        );
        return;
      }

      if (team) {
        const data = yield call(getChartAccesstoWithUuid, chart.uuid);
        if (data.access) {
          actions.push({
            text: '',
            tooltip: {
              text: 'Edit'
            },
            icon: 'fa fa-pencil-alt',
            className: '',
            onClick: () => {
              editChart();
            }
          });
        }
        setNavActions(actions);
        yield put(
          setAction({
            teamId: data.teamID,
            teamName: data.teamName
          })
        );
      }

      yield put(
        setAction({
          chart,
          error: '',
          loadedChart: true,
          username: chart.username,
          chartId: chart.chart_id,
          uuid: chart.uuid,
          twitterUrl: 'https://twitter.com/intent/tweet?url=' + encodeURI(chart.shareLink),
          facebookUrl: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(chart.shareLink)
        })
      );

      yield put(
        createChartAction({
          chart
        })
      );
    } else {
      yield put(
        setAction({
          error: 'No chart configuration was found for the requested chart.'
        })
      );
    }
  } catch (error) {
    console.log('Error:', error);
    yield put(
      setAction({
        error
      })
    );
  }
}

export function* duplicateChart(params) {
  const { team, chart, history } = params.data;
  const config = yield select(getProfileConfig);

  if (!team) return;
  const project = JSON.parse(chart.data);
  const dataset = chart.details;

  if (dataset) {
    const dataset = JSON.parse(chart.details);
    project.settings.dataProvider = dataset;
  }

  if (chart && chart.mapData) {
    //Attach map data to chart config too
    if (!project.options.chart) project.options.chart = {};
    project.options.chart.map = JSON.parse(chart.mapData);
  }

  const body = {
    data: JSON.stringify(project),
    dataId: chart.dataId || null,
    live: chart.live
  };

  try {
    const data = yield call(postTeamChartUsingTeamid, team.id, body);
    yield put(
      setProfileAction({
        chartsCreated: config.chartsCreated + 1
      })
    );
    let newPath = paths.editChartLatest.replace(':chartid', data.chart_id);
    history.push(newPath);
  } catch (error) {
    if (error && error.response && error.response.message && error.response.message[0] === 'Could not create chart') {
      snackBar('Sorry, you have run out of projects');
    } else {
      yield put(
        setAction({
          error: 'duplicating chart: ' + error.message || error
        })
      );
    }
  }
}

export function* editChart(params) {
  let { history, chartId } = params.data;
  const { teamName, teamId } = yield select((state) => state.showChartPage);
  let newPath = paths.editChartLatest.replace(':chartid', chartId);
  localStorage.setItem('editorTeam', JSON.stringify({ id: teamId, name: teamName }));
  history.push(newPath);
}

/** Watch functions */
export function* watchCreateChart() {
  yield takeEvery(actionTypes.ShowChartPage.createChart, createChart);
}
export function* watchCreateLayout() {
  yield takeEvery(actionTypes.ShowChartPage.createLayout, createLayout);
}

export function* watchCreateTable() {
  yield takeEvery(actionTypes.ShowChartPage.createTable, createTable);
}

export function* watchLoadChart() {
  yield takeEvery(actionTypes.ShowChartPage.loadChart, loadChart);
}

export function* watchEditChart() {
  yield takeEvery(actionTypes.ShowChartPage.editChart, editChart);
}

export function* watchDuplicateChart() {
  yield takeEvery(actionTypes.ShowChartPage.duplicateChart, duplicateChart);
}

export default function* rootSaga() {
  yield all([
    watchCreateChart(),
    watchLoadChart(),
    watchEditChart(),
    watchDuplicateChart(),
    watchCreateLayout(),
    watchCreateTable()
  ]);
}
